import React from "react";
import ProposalForm from "forms/ProposalForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("ProposalModal");

const ProposalModal = ({ onClose, onSubmit }) => (
  <Modal onClose={onClose} isOpen>
    <ModalHeader onClose={onClose}>{t("title")}</ModalHeader>
    <ModalBody>
      <ProposalForm onSubmit={onSubmit} />
    </ModalBody>
  </Modal>
);

ProposalModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ProposalModal;
